import { z } from 'zod'

// Create invite with optional multi-use settings
export const createInviteSchema = z.object({
  maxUses: z.number().min(1).max(1000).nullable().optional(),
  expiresInDays: z.number().min(1).max(365).nullable().optional(),
  label: z.string().max(50).optional(),
})

// Join request when approval is required
export const joinRequestSchema = z.object({
  message: z.string().max(500).optional(),
  participationIntent: z.enum(['IN_PERSON', 'ONLINE', 'BOTH']).optional(),
})

// Update club settings (for join approval toggle, public visibility, and local discovery)
export const updateClubSettingsSchema = z.object({
  requireJoinApproval: z.boolean().optional(),
  isPublic: z.boolean().optional(),
  isLocalClub: z.boolean().optional(),
  city: z.string().max(100).nullable().optional(),
  neighborhood: z.string().max(100).nullable().optional(),
  latitude: z.number().min(-90).max(90).nullable().optional(),
  longitude: z.number().min(-180).max(180).nullable().optional(),
  venueType: z.enum(['BOOKSTORE', 'CAFE', 'LIBRARY', 'PARK', 'HOME', 'OTHER']).nullable().optional(),
  meetingCadence: z.enum(['WEEKLY', 'BIWEEKLY', 'MONTHLY', 'FLEXIBLE']).nullable().optional(),
  maxAttendees: z.number().min(2).max(500).nullable().optional(),
  discoverabilityMi: z.number().min(1).max(100).nullable().optional(),
  shareExactLocation: z.boolean().optional(),
})

export type CreateInviteInput = z.infer<typeof createInviteSchema>
export type JoinRequestInput = z.infer<typeof joinRequestSchema>
export type UpdateClubSettingsInput = z.infer<typeof updateClubSettingsSchema>
